import React from "react";
import { DisplayFiltersProps, FilterLayout, useFilterPlugins } from "./filters.plugin";
import { makeGetterSetter } from "@me8eon/context";
import { lensBuilder } from "@me8eon/optics";
import { useThrowError } from "@me8eon/throw_error";
import { parseAttributeValue } from "@me8eon/string_utils";

export const SimpleFilterLayout: FilterLayout =
    ({ children, rootId }) => <div data-testid={rootId} key={rootId} style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px"
    }}>{children}</div>;

export type DisplayAllFiltersProps<Filters> = DisplayFiltersProps<Filters> & {
    options: string[]
}

export function SimpleDisplayFilters<Filters,>({ filtersOps, rootId, options }: DisplayAllFiltersProps<Filters>) {
    const [filters, setFilters] = filtersOps;
    const plugins = useFilterPlugins();
    const FilterLayout = SimpleFilterLayout;
    const throwError = useThrowError();
    return <FilterLayout rootId={rootId}>
        {(options || []).map((filterName, index) => {
            const { attribute, value } = parseAttributeValue(filterName);
            const plugin = plugins[attribute];
            if (!plugin) return throwError("s/w", `No plugin for filter ${filterName}. Legal values are ${Object.keys(plugins).sort()}`);
            const DisplayFilter = plugin.DefaultDisplay;
            if (!DisplayFilter) return null;
            const filterOps = makeGetterSetter(filters, setFilters, lensBuilder<Filters>().focusOn(filterName as any));
            return <DisplayFilter key={`${attribute}-${index}`} rootId={`${rootId}.${attribute}`} filterOps={filterOps} filterName={filterName} value={value} />;
        })}
    </FilterLayout>;
}